import React, { forwardRef, TextareaHTMLAttributes, ReactNode, useContext, useState } from 'react';
import styles from './styles.module.scss';
// import { LayoutContext } from '@/context/LayoutContext';
import ToolbarIcons from '@/icons/toolbar';
import RenderHelpBox from '../RenderHelpBox';
// import RenderHelpBox from '@/components/common/RenderHelpBox';

interface AppTextAreaProps extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'prefix'> {
  className?: string;
  extraWrapperClass?: string;
  wrapper?: string;
  prefix?: ReactNode;
  prefixClass?: string;
  affix?: ReactNode;
  affixStyle?: string;
  onClickInput?: () => void;
  onChange?: any;
  onKeyDown?: (x: any) => void;
  themeColor?: string;
  affixWrapper?: string;
  showError?: boolean;
  error?: string;
  title?: string;
  extraInfoStyle?: string;
  extraInfo?: string;
  disabled?: boolean;
  value?: string | number | undefined;
  showRemoveIcon?: boolean;
  guide?: string;
  inputType?: string;
  showTitle?: boolean;
}

const AppTextArea = forwardRef<HTMLTextAreaElement, AppTextAreaProps>((props, ref) => {
  // const { dir } = useContext(LayoutContext);
  const {
    className,
    extraWrapperClass,
    wrapper,
    prefix,
    prefixClass,
    affix,
    affixStyle,
    onClickInput,
    onChange,
    onKeyDown,
    themeColor = 'default',
    affixWrapper = '',
    showError,
    error = '',
    title = '',
    extraInfoStyle = '',
    extraInfo = '',
    disabled = false,
    value = '',
    showRemoveIcon = true,
    guide,
    inputType = 'textarea',
    showTitle = true,
    ...textareaProps
  } = props;
  const [focused, setFocused] = useState('');

  return (
    <div
      className={`formItem ${styles.wrapperContainer} ${disabled && styles.disabled} ${extraWrapperClass || ''}`}
    >
      {title && showTitle && (
        <div className={`${styles.title} formTitle`}>
          <span>
            {title}
            {extraInfo && <span className={extraInfoStyle}>{extraInfo}</span>}
          </span>
          {guide && <>{RenderHelpBox(title, guide)} </>}
        </div>
      )}
      <div className={`${styles.container}`}>
        <div
          className={`${styles.wrapper}  ${focused == title && `formActiveBorder`} ${showError && 'inputError'} ${wrapper || ''}`}
        >
          {prefix && <div className={prefixClass}>{prefix}</div>}

          <textarea
            {...textareaProps}
            ref={ref}
            className={`${styles.inputClassName} ${className || ''} `}
            onClick={onClickInput}
            onFocus={() => {
              setFocused(title);
              props.onFocus && props.onFocus;
            }}
            onBlur={() => {
              setFocused('');
              props.onBlur && props.onBlur;
            }}
            onChange={onChange ?? (() => console.log('change'))}
            onKeyDown={onKeyDown ?? (() => console.log('keydown'))}
            value={value}
            disabled={disabled}
          />

          {((showRemoveIcon && value) || affix) && (
            <div className={`${styles.affixContainer} ${affixWrapper}`}>
              {showRemoveIcon && value && (
                <ToolbarIcons.CloseCircleIcon
                  width={'16px'}
                  height={'16px'}
                  fill={`#fff`}
                  onClick={() => {
                    props.onChange({ target: { value: '' } });
                  }}
                  className={`${affix && styles.close}`}
                />
              )}
              {affix && <div className={`${styles.affix}`}>{affix}</div>}
            </div>
          )}
        </div>
      </div>
      {showError && <p className="inputErrorText">{error}</p>}
    </div>
  );
});

AppTextArea.displayName = 'AppTextArea';
export default AppTextArea;
